import { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { TourPlacesToGo } from '@assets/icons';
import Tooltip from '@components/ui/Tooltip/next';

import {
  ItemWrapper,
  IconWrapper,
  ItemText,
  ListingItemsWrapper,
  ListingItem,
  TooltipContainer,
} from './styled';

interface Props {
  placesItems: string;
}
const PlacesToGo = ({ placesItems }: Props) => {
  const { palette } = useTheme();
  const placesToGoArr = placesItems?.split(',');

  return (
    <TooltipContainer>
      <Tooltip
        getPopupContainer={(triggerNode) => triggerNode}
        trigger='hover'
        borderRadius='8px'
        overlayInnerStyle={{
          maxHeight: '183px',
          overflow: 'auto',
          borderRadius: '8px',
          border: 'none',
          backgroundColor: palette.white,
          width: '250px',
        }}
        placement='topLeft'
        arrowColor={palette.white}
        title={
          <ListingItemsWrapper>
            {placesToGoArr?.map((item, index) => {
              return <ListingItem key={index}>{item}</ListingItem>;
            })}
          </ListingItemsWrapper>
        }
      >
        <ItemWrapper>
          <IconWrapper>
            <CustomIcon
              paletteColor='NL800'
              icon={TourPlacesToGo}
              width={16}
              height={16}
            />
          </IconWrapper>
          <ItemText>Tur Güzergahı</ItemText>
        </ItemWrapper>
      </Tooltip>
    </TooltipContainer>
  );
};

export default PlacesToGo;
